<template>
  <div
    class="menu-item-wrapper"
    ref="wrapper"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div class="menu-item" :class="{ active: isActive, collapse: isCollapsed }" @click="handleClick">
      <img :src="labelimage" :alt="menuname" class="menu-icon" />
      <div class="menunamewrapper">
        <span class="menu-name">{{ menuname }}</span>
        <div v-if="isActive" class="activebar"></div>
      </div>
      <svg
        v-if="collapsable"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        class="arrow-icon"
        :class="{ 'arrow-up': isCollapsed }"
      >
        <path
          d="M6.23 20.23L8 22l10-10L8 2L6.23 3.77L14.46 12z"
          fill="currentColor"
        ></path>
      </svg>
    </div>
    <div v-if="collapsable && isCollapsed" class="dropdown-panel">
      <img
        class="dropdown-arrow"
        :style="{ left: arrowLeft + 'px' }"
        src="https://ustatic.hudongmiao.com/miao/common/arrow-icon_1783997705835629c2d.webp"
        alt=""
      />
      <div class="dropdown-box">
        <div class="dropdown-content" :style="{ paddingLeft: contentLeft + 'px' }">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    collapsable: {
      type: Boolean,
      default: false,
    },
    labelimage: {
      type: String,
      required: true,
    },
    menuname: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapsed: false,
      arrowLeft: 0,
      contentLeft: 0,
    };
  },
  computed: {
    isActive() {
      return this.active;
    },
  },
  mounted() {
    this.updateDropdownPosition();
    window.addEventListener('resize', this.updateDropdownPosition);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDropdownPosition);
  },
  methods: {
    updateDropdownPosition() {
      const el = this.$refs.wrapper;
      if (!el) {
        return;
      }
      const rect = el.getBoundingClientRect();
      this.arrowLeft = rect.left + rect.width / 2;
      this.contentLeft = rect.left;
    },
    handleMouseEnter() {
      // 无论是否可展开，hover 时都应用特殊样式
      this.isCollapsed = true;
      this.$nextTick(() => {
        this.updateDropdownPosition();
      });
    },
    handleMouseLeave() {
      // 鼠标移出时还原样式
      this.isCollapsed = false;
    },
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="less" scoped>
.menu-item-wrapper {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .dropdown-panel {
    position: fixed;
    top: 62px;
    left: 0;
    width: 100%;
    z-index: 999;
  }

  .dropdown-arrow {
    position: absolute;
    top: -12px;
    width: 21px;
    height: 13px;
    transform: translateX(-50%);
    z-index: 2;
    pointer-events: none;
  }

  .dropdown-box {
    width: 100%;
    background: #fff;
    border-top: 1px solid #7B4BFE;
    border-bottom: 1px solid #7B4BFE;
    padding: 18px 0;
  }

  .dropdown-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    box-sizing: border-box;
  }
}
</style>

<style lang="less">
.menu-item {
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  cursor: pointer;
  
  .menu-icon {
    margin-top: 4px;
    width: 13px;
    height: 13px;
  }
  
  .menunamewrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    margin-left: 4px;
    
    .menu-name {
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      color: #333;
    }
    
    .activebar {
      height: 3px;
      background: linear-gradient(90deg, #7B4BFE 0%, #CD5EFB 100%);
      margin-top: auto;
      border-radius: 2px;
    }
  }
  
  .arrow-icon {
    width: 10px;
    height: 10px;
    transform: rotate(90deg);
    color: #8F8F8F;
    margin-left: 4px;
    margin-top: 5px;
    transition: transform 0.3s ease;
    
    &.arrow-up {
      transform: rotate(270deg);
    }
  }
  
  &.active {
    .menu-name {
      background: linear-gradient(270deg, #7B4BFE 0%, #CD5EFB 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  &.collapse {
    .menu-name {
      background: linear-gradient(270deg, #7B4BFE 0%, #CD5EFB 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
}
</style>
